import { SVGProps } from 'react';

const BellScaleSmallCrossedFalse = (props: SVGProps<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M9.33333 14C9.19783 14.2028 9.00335 14.3711 8.76934 14.4881C8.53534 14.6051 8.27004 14.6667 8 14.6667C7.72996 14.6667 7.46465 14.6051 7.23065 14.4881C6.99665 14.3711 6.80216 14.2028 6.66666 14M2.66666 11.3333V9.33334C2.66666 9.33334 4.13628 8.62258 4.19236 7.24982V4.52514C4.25556 2.96907 5.86666 1.33535 7.64444 1.33421C9.42222 1.33306 6.57778 1.33306 8.35926 1.33419C10.1408 1.33532 11.7444 2.96907 11.8076 4.52514V7.24982C11.8637 8.62263 13.3333 9.33334 13.3333 9.33334V11.3333H2.66666Z"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={1.33333}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default BellScaleSmallCrossedFalse;
